import { moveToFulfilled } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { FeedLoadFulfilledAction } from '../../domains/feedLoad/actions.types';

import type { TargetingRules } from './types';

export type TargetingRuleAction = FeedLoadFulfilledAction;

const initialState: TargetingRules = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<TargetingRules, TargetingRuleAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.targetingRules);
    default:
      return state;
  }
};

export default reducer;
